const MAX_QOUTATIONS = 5;
const TYPE_DICTIONARY = {
	EMPLOYEE: 'employee',
	CUSTOMER: 'customer',
	PARTNER: 'partner'
};

export const UniversalQoutationDisplayerComponent = {
	bindings: {
		type: '@',
		maxCount: '@'
	},
	templateUrl: 'universal-qoutation-displayer.html',
	controller: class UniversalQoutationDisplayerComponent {
		constructor(QoutationService) {
			'ngInject';
			this.qoutationService = QoutationService;
		}

		$onChanges(changes) {
			if (changes.type) {
				let ajaxParam = '';
				switch (this.type) {
					case TYPE_DICTIONARY.EMPLOYEE:
						ajaxParam = 'getEmployeeQoutations';
						break;
					case TYPE_DICTIONARY.CUSTOMER:
						ajaxParam = 'getCustomerQoutations';
						break;
					case TYPE_DICTIONARY.PARTNER:
						ajaxParam = 'getPartnerQoutations';
						break;
					default:
						ajaxParam = 'getEmployeeQoutations';
						break;
				}
				this.maxNum = angular.copy(this.maxCount) || MAX_QOUTATIONS;
				this.getQuotations(ajaxParam);
			}
		}

		getQuotations(ajaxParam) {
			this.qoutationService[ajaxParam](this.maxNum).then((response) => {
				this.qoutationList = angular.copy(response.data);
				if (this.qoutationList.length > MAX_QOUTATIONS) {
					let shuffled = this.shuffledList(this.qoutationList);
					this.qoutationList = shuffled.slice(0, MAX_QOUTATIONS);
				}
			}).catch((err) => {
				console.log(err);
			});
		}

		shuffledList(array) {
			return array.sort(() => Math.random() - 0.5);
		}
	}
};
